import React from 'react'
import { Grid, GridProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

const YumGrid = withStyles(
  (theme: Theme) => createStyles({}),
  // @ts-ignore
)(({ classes, children, ...props }: GridProps) => {
  const childrenArr = React.Children.toArray(children)
  const firstChild = childrenArr[0]
  const secondChild = childrenArr[1]
  return (
    <Grid classes={classes} container justifyContent="space-between" alignContent="center" wrap="nowrap" {...props}>
      {firstChild && <Grid item>{firstChild}</Grid>}
      {secondChild && <Grid item>{secondChild}</Grid>}
    </Grid>
  )
})

export default YumGrid
